import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [ToastComponent],
  template: `
    <div class="fixed top-5 right-5 z-[200] flex flex-col gap-2.5
                pointer-events-none w-[min(420px,calc(100vw-40px))]">
      @for (t of toastService.toasts(); track t.id) {
        <app-toast [toast]="t" (dismissed)="toastService.dismiss($event)" />
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);
}
